module.exports = __webpack_public_path__ + "static/img/9w.5ba6bab.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/9w.webp
// module id = 8gt+
// module chunks = 0